import Api from '@/api'
const resource = 'real_estates'

export default {
  delete (id) {
    return Api.delete(`/${resource}/${id}`)
  },

  estimate (id, options) {
    return Api.post(`/${resource}/${id}/estimate`, options)
  },

  fetchById (id) {
    return Api.get(`/${resource}/${id}`)
  },

  fetchEstimate (id) {
    return Api.get(`/${resource}/${id}/estimate`)
  },

  update (id, data) {
    return Api.put(`/${resource}/${id}`, { real_estate: data })
  }
}
